export const getMessageCode = (index?: number): string | null => {
  if (index === undefined) {
    return null;
  }
  return ['lost-shoppers-value', 'shopper-audience'][index] || 'lost-shoppers-value';
};
